import React from 'react';
import { StopOutlined } from '@ant-design/icons';

/**
 * Unauthorized Component
 * Displays when user doesn't have valid accessToken
 */
const Unauthorized: React.FC = () => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        padding: '20px',
    }}
    >
        <StopOutlined style={{
            fontSize: '64px',
            color: '#ff4d4f',
            marginBottom: '24px',
        }}
        />
        <h1 style={{
            fontSize: '24px',
            fontWeight: 600,
            color: '#262626',
            marginBottom: '12px',
            textAlign: 'center',
        }}
        >
            Not Authorized
        </h1>
        <p style={{
            fontSize: '14px',
            color: '#8c8c8c',
            textAlign: 'center',
            maxWidth: '400px',
        }}
        >
            You do not have permission to access this page.
            Please contact your administrator for assistance.
        </p>
    </div>
);

export default Unauthorized;
